export default class ContactAddController {
    /* @ngInject */
    constructor($scope, $state, $stateParams, $ionicPopup, $ionicLoading, ApiInvestors, ApiCampaigns, ApiPicklist, ApiTeam, $rootScope) {
        this.ApiInvestors = ApiInvestors;
        this.ApiPicklist = ApiPicklist;
        this.ApiTeam = ApiTeam;
        this.$state = $state;
        this.$ionicLoading = $ionicLoading;
        this.$stateParams = $stateParams;
        this.$ionicPopup = $ionicPopup;
        this.$rootScope = $rootScope;

        // Prerequisites
        this.investor = {};

        this.investorId = $stateParams.investorId;
        this.isCustomerInvestor = false;
        this.editMode = false; // flag true if new entry
        this.createInvestor = false;
        this.translationVisible = false;
        this.advindaCount =this.$stateParams.advindaCount;
        this.customCount =this.$stateParams.customCount;

        this.cleaveNumeral = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
        }
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>',
            duration: 10000
        });
        this.$rootScope.pageTitle = 'CREATE_ACCOUNT';

        /**
         * Checking if edit mode
         */
        if (this.$stateParams.investorId) {
            this.editMode = true; // enable the edit flag
            this.$rootScope.pageTitle = 'EDIT_INVESTOR_ACCOUNT';

            // Load contact from database
            this.ApiInvestors.getInvestor(this.investorId, { 'isCustomerAccount': true }).then((res) => {
                if (typeof res != 'undefined') {
                    this.investor = res.investor;
                    this.$ionicLoading.hide();
                } else {
                    this.$ionicLoading.hide();
                }
            });

        } else {
            this.$ionicLoading.hide();
        }

        this.ApiPicklist.getInvestorTypes().then((investorTypes) => {
            this.investorTypes = investorTypes.data.map((investorType) => {
                return investorType.type;
            });
        });

        this.ApiPicklist.getAdvindaCountries().then((advindaCountries) => {
            this.advindaCountries = advindaCountries.data;
            this.advindaCountries.unshift("");
        });

        this.getTeams();
    }

    saveInvestor() {
        // edit campaign
        if (this.editMode) {
            this.ApiInvestors.putInvestor(this.investor).then((res) => {
                if (res) {
                    this.$state.go('investors', {}, { reload: true });
                } 
            });
        } else {
            this.ApiInvestors.postInvestor(this.investor).then((res) => {
                if (res) {
                    this.$state.go('investors', {}, { reload: true });
                }
            });

        }
    }

    getTeams(){

        this.ApiTeam.getTeams().then((res) => {
            if (typeof res != 'undefined') {
                if (res) {
                    this.translationVisible = res.translationRequired;
                }
            }
        });
    }

}



/** WEBPACK FOOTER **
 ** ./src/app/components/investors/investorAdd.controller.js
 **/